import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import 'antd/dist/antd.css'
import 'tachyons/css/tachyons.min.css'
import { Main } from './views/main'
import * as serviceWorker from './serviceWorker'
import './web.config'
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { getMsalConfig } from 'connection/AuthConfig';
import { LoadingFactory as LoadingFactory, LOADING_TYPES } from 'components/LoadingFactory'

const MainMsal = () => {
  const [msalConfig, setMsalConfig] = useState(null)
  const [msalInstance, setMsalInstance] = useState(null)

  useEffect(() => {
    const getConfig = async () => {
      !msalConfig ? setMsalConfig(await getMsalConfig()) : setMsalInstance(new PublicClientApplication(msalConfig))
    }
    if (!msalInstance)
      getConfig()
  }, [msalConfig,msalInstance])

  return (
    <>
      {
        msalInstance ? (
          <MsalProvider instance={msalInstance}>
            <Main />
          </MsalProvider>
        ) : <LoadingFactory type={LOADING_TYPES.Fullscreen} />
      }
    </>
  )
}

ReactDOM.render(
  <MainMsal />
  ,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
